import React, { useState } from 'react'
import { Table, Button } from 'reactstrap';

export default function QuickPickTable(props) {
    /*eslint-disable */
    const [collectionResult, setCollectionResult] = useState(false)
    /*eslint-enable */
    const bookOutItem = async (type, watchDigits) => {
        try {
            const response = await fetch(
                `/api/v1/SafeManagement/bookOut/${type}/${watchDigits}?token=${props.token}`,
                {
                    method: "get",
                    headers: new Headers({
                        // "Content-Type": "application/json",
                    }),
                }
            )
            /*eslint-disable */
            if (response.status == 401) {
                /*eslint-enable */
                window.location.href = '/SafeManagement?authRedirect=QuickPick';
            } else if (!response.ok) {
                alert(response.status + '. Status text is:' + response.statusText + ". Fehler beim Ausbuchent");
                console.log(response)
            }
            const payload = response;
            setCollectionResult(payload);
            if (response.ok) {
                switch (type) {
                    case 'watch':
                        props.setWatchCollect(true)
                        break;
                    case 'box':
                        props.setBoxCollect(true)
                        break;
                    case 'papers':
                        props.setPaperCollect(true)
                        break;
                    default:
                        console.log("default switch result")
                }
            }
        } catch (e) {
            console.log(e);
            alert('unsuccessful connecting');
        }
    };
    return (
        <div>
            <Table bordered striped hover>
                <thead>
                    <tr>
                        <th>Typ</th>
                        <th>Lagerort</th>
                        <th>Aktion</th>
                    </tr>
                </thead>
                {props.watchInfo &&
                    <tbody>
                        <tr style={props.watchCollect ? { backgroundColor: "#00FA9A" } : {}}>
                            <td><b>Uhr</b></td>
                            <td>
                                <b>{props.watchInfo.watchLocation ? props.watchInfo.watchLocation : 'Uhren-Lagerort nicht gefunden!'}</b>
                            </td>
                            <td>
                                <Button
                                    className="w100percentage"
                                    color={props.watchCollect ? "success" : "primary"}
                                    disabled={(props.watchInfo.watchLocation && !props.watchCollect) ? false : true}
                                    onClick={() => { bookOutItem("watch", props.watchDigits) }}
                                > {props.watchCollect ? 'Ausgebucht' : 'Ausbuchen'} </Button>
                            </td>
                        </tr>
                        <tr style={props.boxCollect ? { backgroundColor: "#00FA9A" } : {}}>
                            <td><b>Box</b></td>
                            <td>
                                <b>{props.watchInfo.boxLocation ? props.watchInfo.boxLocation : 'Box-Lagerort nicht gefunden!'}</b>
                            </td>
                            <td>
                                <Button
                                    className="w100percentage"
                                    color={props.boxCollect ? "success" : "primary"}
                                    onClick={() => { bookOutItem("box", props.watchDigits) }}
                                    disabled={(props.watchInfo.boxLocation && !props.boxCollect) ? false : true}
                                > {props.boxCollect ? 'Ausgebucht' : 'Ausbuchen'} </Button>
                            </td>
                        </tr>
                        <tr style={props.paperCollect ? { backgroundColor: "#00FA9A" } : {}}>
                            <td><b>Papiere</b></td>
                            <td>
                                <b>{props.watchInfo.paperLocation ? props.watchInfo.paperLocation : 'Dokumenten-Lagerort nicht gefunden!'}</b>
                            </td>
                            <td>
                                <Button
                                    className="w100percentage"
                                    color={props.paperCollect ? "success" : "primary"}
                                    disabled={(props.watchInfo.paperLocation && !props.paperCollect) ? false : true}
                                    onClick={() => { bookOutItem("papers", props.watchDigits) }}
                                > {props.paperCollect ? 'Ausgebucht' : 'Ausbuchen'} </Button>
                            </td>
                        </tr>
                    </tbody>
                }
            </Table>
        </div>
    )
}
